import React from 'react';
import WhatsNew from './WhatsNew';
import HolidayContentModal from './HolidayContent/HolidayContentModal';
import UpdateAppModal from 'Core_Pages/Home/Modals/UpdateAppModal/UpdateAppModal';
import FoodBoxModal from './FoodBoxModal/FoodBoxModal';
import AppMigrationNotificationModal from './AppMigrationNotificationModal/AppMigrationNotificationModal';
import AppMigrationTakeoverModal from './AppMigrationTakeoverModal/AppMigrationTakeoverModal';

const Modals = () => {
  return (
    <>
      <AppMigrationTakeoverModal />
      <AppMigrationNotificationModal />
      <UpdateAppModal />
      <WhatsNew />
      <HolidayContentModal />
      <FoodBoxModal />
    </>
  );
};

export default Modals;
